import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import * as React from "react";

const SampleRequestConfirmationPage = ({ id }: PageProps) => (
    <MobiusPage>
        <Zone contentId={id} zoneName="Content" />
    </MobiusPage>
);

const pageModule: PageModule = {
    component: SampleRequestConfirmationPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        fieldDefinitions: [
            {
                name: "overrideTitle",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "General",
                displayName: "Override Title",
                sortOrder: 0,
            },
        ],
        pageType: "Content",
    },
};

export default pageModule;
